export const UPDATE_LVZ_MARKER_DATA = 'UPDATE_LVZ_MARKER_DATA'

export function lvzMarkerDataReducer (state = {}, action) {
    switch (action.type){
        case UPDATE_LVZ_MARKER_DATA:
            return action.payload
        default: return state
    }
}